// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"UploadStep_dashboardContainer__VAgkR"};